import QRCodeGenerator from "../360View/QRCodeGenerator"

const columns = [
  {
    name: 'Company Name',
    selector: (row) => row.company,
  },
  {
    name: 'Size',
    selector: (row) => row.size,
  },
  {
    name: 'Finish',
    selector: (row) => row.finish,
  },
  {
    name: 'Product',
    selector: (row) => row.product,
  },
  {
    name: 'QR Code',
    selector: (row) => <QRCodeGenerator id={row._id} size={50} />,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
